export const getTrackingNumbers = ({ customerTrackingNumber, merchantTrackingNumber, returnLabels = [] }) => {
  const customerAndMerchantTrackingNumbers = []

  if (customerTrackingNumber) {
    customerAndMerchantTrackingNumbers.push({ tracking_number: customerTrackingNumber })
  }

  merchantTrackingNumber?.forEach(trackingNumber => {
    customerAndMerchantTrackingNumbers.push({ tracking_number: trackingNumber })
  })

  return [...returnLabels, ...customerAndMerchantTrackingNumbers]
}

export const hasDiscardableLabels = (returnLabels = []) => returnLabels.some(label => !label.discarded_at)
